module.exports = __webpack_public_path__ + "mk.svg?07759242b1fa6fc3047530618e5154ed";